import { useEffect, useState } from 'react';
import { GridRowsProp, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Box } from '@mui/material';

import { useTranslation } from 'react-i18next';

import IEmailNotification from '../../interfaces/IEmailNotification';
import CAppDataGrid from '../../../../app/components/CAppDataGrid';
import AppFormatDate from '../../../../app/features/format/AppFormatDate';
import langAdminEmailNotifications from '../../langs/langAdminEmailNotifications';

type CAdminEmailNotificationTableProps = {
	emailNotifications: IEmailNotification[];
};
const CAdminEmailNotificationTable = (props: CAdminEmailNotificationTableProps) => {
	const { emailNotifications } = props;

	const { t } = useTranslation();

	const [rows, setRows] = useState<GridRowsProp | null>(null);

	useEffect(() => {
		if (emailNotifications) {
			setRows(
				emailNotifications.map((x, index) => ({
					id: index,
					fundName: x.fund?.name,
					userEmail: x.user?.email,
					documentName: x.document?.name,
					documentReleaseDate: x.documentReleaseDate,
					notificationSubject: x.notification?.subject,
					notificationCc: x.notification?.cc,
					notificationSendDatetime: x.notification?.sendDatetime,
					notificationSendStatus: x.notification?.statusTag,
				})),
			);
		}
	}, [emailNotifications]);

	const columns: GridColDef[] = [
		{
			field: 'fundName',
			headerName: t(langAdminEmailNotifications.column_fund_name.tag),
			minWidth: 200,
			flex: 1,
			align: 'left',
			headerAlign: 'left',
		},
		{
			field: 'documentName',
			headerName: t(langAdminEmailNotifications.column_document_name.tag),
			width: 200,
			align: 'left',
			headerAlign: 'left',
		},
		{
			field: 'userEmail',
			headerName: t(langAdminEmailNotifications.column_user_email.tag),
			width: 200,
			align: 'left',
			headerAlign: 'left',
		},
		{
			field: 'documentReleaseDate',
			headerName: t(langAdminEmailNotifications.column_document_release_date.tag),
			width: 150,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params: GridRenderCellParams) => <AppFormatDate date={params.value} />,
		},
		{
			field: 'notificationSubject',
			headerName: t(langAdminEmailNotifications.column_notification_subject.tag),
			width: 120,
			align: 'left',
			headerAlign: 'left',
		},
		{
			field: 'notificationCc',
			headerName: t(langAdminEmailNotifications.column_notification_cc.tag),
			width: 120,
			align: 'left',
			headerAlign: 'left',
		},
		{
			field: 'notificationSendDatetime',
			headerName: t(langAdminEmailNotifications.column_notification_send_datetime.tag),
			width: 150,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params: GridRenderCellParams) => <AppFormatDate date={params.value} />,
		},
		{
			field: 'notificationSendStatus',
			headerName: t(langAdminEmailNotifications.column_notification_send_status.tag),
			width: 120,
			align: 'left',
			headerAlign: 'left',
		},
	];

	return (
		<>
			{rows ? (
				<Box>
					<CAppDataGrid
						className="admin-email-notifications-table"
						rows={rows}
						columns={columns}
						autoHeight
						pagination
					/>
				</Box>
			) : (
				''
			)}
		</>
	);
};

export default CAdminEmailNotificationTable;
